import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTasyarBrand } from '../lib/tasyarBrand';
import ThemeToggleButton from '../components/landing/ThemeToggleButton';

export default function PublicCoachHeader({ title, dark, theme, onToggleTheme }) {
  const navigate = useNavigate();
  const brand = useTasyarBrand();

  if (dark) {
    return (
      <header className="fixed inset-x-0 top-0 z-30 border-b border-teal-900/30 bg-[#0A192F]/90 backdrop-blur-xl" dir="rtl" data-testid="public-coach-header">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-2 px-4 py-3 sm:px-5 sm:py-4">
          <button onClick={() => navigate('/')} className="flex min-w-0 items-center gap-2" data-testid="coach-header-home-btn">
            {brand.iconUrl ? (
              <img src={brand.iconUrl} alt="تسيار" className="h-7 w-7 shrink-0 rounded-lg object-contain sm:h-8 sm:w-8" data-testid="coach-header-brand-icon" />
            ) : (
              <span className="h-7 w-7 shrink-0 rounded-lg bg-teal-500/20 sm:h-8 sm:w-8" />
            )}
            <span className="truncate font-display text-base font-black text-white sm:text-lg">{brand.name}</span>
            {title && <span className="hidden text-slate-500 sm:inline"> / {title}</span>}
          </button>
          <div className="flex shrink-0 items-center gap-1.5 sm:gap-4">
            {onToggleTheme && <ThemeToggleButton theme={theme} onToggle={onToggleTheme} />}
            <button onClick={() => navigate('/coaches/directory')} className="hidden text-sm font-medium text-slate-300 hover:text-white sm:inline" data-testid="coach-header-directory-link">دليل المدربين</button>
            <button onClick={() => navigate('/login')} className="rounded-full border border-white/20 px-3 py-1.5 text-xs font-semibold text-white hover:border-white/50 hover:bg-white/10 sm:px-4 sm:py-2 sm:text-sm" data-testid="coach-header-login-btn">
              <span className="sm:hidden">دخول</span>
              <span className="hidden sm:inline">تسجيل الدخول</span>
            </button>
          </div>
        </div>
      </header>
    );
  }

  return (
    <header className="fixed inset-x-0 top-0 z-30 border-b border-slate-200 bg-white/90 backdrop-blur-xl" dir="rtl" data-testid="public-coach-header">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-2 px-4 py-3 sm:px-5 sm:py-4">
        <button onClick={() => navigate('/')} className="flex min-w-0 items-center gap-2 text-slate-900" data-testid="coach-header-home-btn">
          {brand.iconUrl ? (
            <img src={brand.iconUrl} alt="تسيار" className="h-7 w-7 shrink-0 rounded-lg object-contain sm:h-8 sm:w-8" data-testid="coach-header-brand-icon" />
          ) : (
            <span className="h-7 w-7 shrink-0 rounded-lg bg-[#0f2a4a] sm:h-8 sm:w-8" />
          )}
          <span className="truncate font-extrabold bg-gradient-to-l from-[#0f2a4a] to-[#0d9488] bg-clip-text text-base text-transparent sm:text-lg">{brand.name}</span>
          {title && <span className="hidden text-slate-400 sm:inline"> / {title}</span>}
        </button>
        <div className="flex shrink-0 items-center gap-1.5 sm:gap-4">
          {onToggleTheme && <ThemeToggleButton theme={theme} onToggle={onToggleTheme} className="border-slate-300 bg-slate-100 text-slate-600 hover:border-teal-500/50 hover:text-teal-600" />}
          <button onClick={() => navigate('/coaches/directory')} className="hidden text-sm font-medium text-slate-600 hover:text-slate-900 sm:inline" data-testid="coach-header-directory-link">دليل المدربين</button>
          <button onClick={() => navigate('/login')} className="rounded-full border border-slate-300 px-3 py-1.5 text-xs font-semibold text-slate-700 hover:border-[#0d9488] hover:text-[#0d9488] sm:px-4 sm:py-2 sm:text-sm" data-testid="coach-header-login-btn">
            <span className="sm:hidden">دخول</span>
            <span className="hidden sm:inline">تسجيل الدخول</span>
          </button>
        </div>
      </div>
    </header>
  );
}
